const AUTH_TOKEN = "auth-token"

export { AUTH_TOKEN }
